/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Knowledge_Docs_HeadingInputs */

const en_ai_knowledge_docs_heading = /** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Knowledge Documents`)
};

const id_ai_knowledge_docs_heading = /** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Pengetahuan AI`)
};

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const es_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const fr_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const de_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const ja_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const zh_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const ar_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const it_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const ru_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const pt_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/** @type {(inputs: Ai_Knowledge_Docs_HeadingInputs) => LocalizedString} */
const ko_ai_knowledge_docs_heading = en_ai_knowledge_docs_heading;

/**
* | output |
* | --- |
* | "AI Knowledge Documents" |
*
* @param {Ai_Knowledge_Docs_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_knowledge_docs_heading = /** @type {((inputs?: Ai_Knowledge_Docs_HeadingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Knowledge_Docs_HeadingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_knowledge_docs_heading(inputs)
	if (locale === "es") return es_ai_knowledge_docs_heading(inputs)
	if (locale === "fr") return fr_ai_knowledge_docs_heading(inputs)
	if (locale === "de") return de_ai_knowledge_docs_heading(inputs)
	if (locale === "ja") return ja_ai_knowledge_docs_heading(inputs)
	if (locale === "zh") return zh_ai_knowledge_docs_heading(inputs)
	if (locale === "ar") return ar_ai_knowledge_docs_heading(inputs)
	if (locale === "id") return id_ai_knowledge_docs_heading(inputs)
	if (locale === "it") return it_ai_knowledge_docs_heading(inputs)
	if (locale === "ru") return ru_ai_knowledge_docs_heading(inputs)
	if (locale === "pt") return pt_ai_knowledge_docs_heading(inputs)
	return ko_ai_knowledge_docs_heading(inputs)
});